/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// import Component from 'inferno-component';
// STYLES
// (css-in-js, imported as JS from external file, turned into CSS via library used in utils)
import styles from 'components/shared/contentindicator/contentindicator_styles';
import { createStyles } from 'utils/styles';
const sheet = createStyles(styles, {link:false});



/* ========== ~~~~~~~~~~ CONTENT INDICATOR : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
const ContentIndicator = (props) => {
	function handleContentTypeCases() {
		// Don't show this Indicator on the Question Rewards Phase
        if (shouldRemoveIndicator()) { return ''; }
		switch (props.currentContentSettings.type) {
			case 'quiz':
			case 'poll':
            case 'story':
			case 'mixed':
				return props.currentContentData ? handleContentIndicatorCopy(props.currentContentData.type) : '';
			case 'marketResearch':
				return props.abTestVersion ? props.abTestVersion === 'DEFAULT' ? 'Research' :  'Survey' : 'Research'; // props.currentContentSettings.type;
			case 'questionnaire':
				return 'Question';
			case 'userDataCollection':
				return 'Email';
			default:
				return '';
		}
	}
	function handleContentIndicatorCopy (currentContentDataType) {
		switch (currentContentDataType) {
            case 'quiz':
            case 'poll':
            case 'mixed':
                return currentContentDataType;
            case 'story':
                return 'featured story';
        }
	}
	function shouldRemoveIndicator() {
		if (props.currentContentSettings.type === 'questionnaire') {
			return props.screenStatus.visible;
		} else {
            return props.currentContentStatus.uniqueState !== undefined &&
                props.currentContentStatus.uniqueState.frameStatus &&
				!!props.currentContentStatus.uniqueState.frameStatus[props.currentContentStatus.frame] &&
                props.currentContentStatus.uniqueState.frameStatus[props.currentContentStatus.frame]['state'].includes('rewards');
		}

	}
	function showColon() {
		const isStory = props.currentContentData ? props.currentContentData.type !== 'story' : true;
        // Don't show semicolon on the Question Rewards Phase
        if (shouldRemoveIndicator()) { return ''; }
		return isStory && props.rewardsEnabled && props.rewardsPermitted ? ': ' : '';
	}
	return (
        <span className={`${sheet.classes.contentindicator} ${props.currentContentData ? props.currentContentData.type: ''} contentindicator`}>
        	{`${handleContentTypeCases()}${showColon()}`}
        </span>
	);
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default ContentIndicator;
